<template lang="pug">
  .searching.container.mx-auto(v-if="(pages && pages.loading) || loading")
    Spinner(:size="10" :thickness="2")
  .found.container.mx-auto(v-else-if="query" ref="container")
    template(v-if="pages && pages.items && pages.items.length")
      .alert
        p Ihre Suchanfrage nach "<b>{{ query }}</b>" ergab folgende Ergebnisse:
      template(v-if="resultPages")
        Results.teaser(v-for="page in resultPages", :page="page" :key="page.id") 
      Pagination(
        v-if="pageInfo && pageInfo.lastPage > 1"
        :last-page="pageInfo.lastPage"
        :current-page="pageInfo.currentPage"
        nav-class="pagination is-rounded is-centered"
        @change="changePage"
      )
        template(v-slot:prev)
          span.icon
            i.fas.fa-arrow-left
        template(v-slot:next)
          span.icon
            i.fas.fa-arrow-right
    .alert.warning(v-else)
      p Es wurden keine mit Ihrer Suchanfrage - "<b>{{ query }}</b>" - übereinstimmenden Artikel/Seiten gefunden.
</template>

<script>
import { mapActions } from 'vuex';
import { get, cloneDeep } from '@/helpers';

import Results from './Results';


export default {
    name: 'SearchResults',
    data: () => ({
        loading: false,
        pages: undefined,
        pageInfo: undefined
    }),
    props: {
        section: {
            type: Object,
            required: true
        },
        perPage: {
            type: Number,
            default: 24
        }
    },
    components: {
        Results
    },
    watch: {
        '$route.query'(query) {
            window.scrollTo(0, 0);
            this.currentPage = get(query, `P${this.section.id}`) || 1;
            this.refetch(this.query);
        }
    },
    computed: {
        query() {
            return get(this.$route, 'query.s');
        },
        resultPages() {
            let pages = [];
            if(this.pages && this.pages.items && this.pages.items.length) {
                pages = get(this.pages, 'items');
            }
            return pages;
        }
    },
    methods: {
        async refetch(query) {
            if (!query) return false;
            this.loading = true;
            this.pages = undefined; 
            
            const payload = {
                pageInfo: {
                    currentPage: this.currentPage,
                    perPage: 15
                },
                filters: [
                    
                    {
                        key: 'search',
                        like: this.query
                    }
                ]
            };

            this.fetchPages(payload).then(response => {
                if (response.pageInfo.currentPage > response.pageInfo.lastPage) {
                    this.changePage(response.pageInfo.lastPage);
                    return;
                }

                const pages = cloneDeep(response);
                const container = document.querySelector('.preorder-columns > .column.left > .ps');
                if (container) container.scrollTop = 0;

                this.pages = pages;
                this.loading = false;
            });
        },
        ...mapActions({
            // fetchProduct: 'shop/fetchProduct',
            // fetchArticles: 'shop/fetchArticles',
            // addArticleToCart: 'shop/addArticleToCart',
            fetchPages: 'fetchCategoryPostTeasers'
        })
    },
    mounted() {
        this.$nextTick(() => {
            if (this.query) {
                this.refetch(this.query);
            } else {
                this.pages.loading = false;
            }
        });
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.searching,
.found
    @apply my-6
    min-height: 4rem 

    .teaser
        @apply border-b-2 border-solid mb-6 pb-6
        border-color: $color-primary
        &:last-of-type
            border: 0


.alert
  margin-bottom: 2rem

.pages ::v-deep .arrow-container
  display: none
</style>
